'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.contactsLimitsDependenciesSelector = exports.emailSendMultiplierSelector = exports.minPurchasableContactsSelector = exports.purchasedContactsQuantitySelector = exports.purchasedContactsUnitsSelector = exports.contactsQuantityMultiplierSelector = exports.numContactsInCrmSelector = undefined;

var _reselect = require('reselect');

var _ImmutableMerchandiseIdMap = require('self-service-api/constants/ImmutableMerchandiseIdMap');

var _ImmutableMerchandiseIdMap2 = _interopRequireDefault(_ImmutableMerchandiseIdMap);

var _ProductOwnershipSelectors = require('pricing-pages-unified-ui/selectors/ProductOwnershipSelectors');

var _ParcelGroups = require('pricing-pages-unified-ui/constants/ParcelGroups');

var _MerchandiseSelectors = require('pricing-pages-unified-ui/selectors/MerchandiseSelectors');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var numContactsInCrmSelector = exports.numContactsInCrmSelector = function numContactsInCrmSelector(_ref) {
  var numContactsInCrm = _ref.numContactsInCrm;
  return numContactsInCrm;
};

// Returns the contacts quantity multiplier for the additionalUnitMerchId of the activeMerchId
var contactsQuantityMultiplierSelector = exports.contactsQuantityMultiplierSelector = (0, _reselect.createSelector)([_MerchandiseSelectors.merchandiseSelector, function (_, merchandiseId) {
  return merchandiseId;
}], function (merchandise, merchandiseId) {
  if (!merchandise || !merchandiseId) return null;
  var additionalUnitMerchId = _ImmutableMerchandiseIdMap2.default[merchandiseId].additionalUnitMerchId;

  if (!additionalUnitMerchId) return null;
  return merchandise[additionalUnitMerchId].quantityMultiplier;
});

// returns amount of contacts units a user has purchased
var purchasedContactsUnitsSelector = exports.purchasedContactsUnitsSelector = (0, _reselect.createSelector)(_ProductOwnershipSelectors.parcelsSelector, function (parcels) {
  var contactsParcel = parcels.find(function (_ref2) {
    var parcelName = _ref2.parcelName;
    return _ParcelGroups.ADDITIONAL_CONTACTS.includes(parcelName);
  });
  var hasNoPurchasedContacts = !contactsParcel;
  if (hasNoPurchasedContacts) return 0;

  return contactsParcel.quantity;
});

// returns amount of contacts a user has purchased
var purchasedContactsQuantitySelector = exports.purchasedContactsQuantitySelector = (0, _reselect.createSelector)([purchasedContactsUnitsSelector, contactsQuantityMultiplierSelector], function (purchasedContactsUnits, contactsQuantityMultiplier) {
  return purchasedContactsUnits * contactsQuantityMultiplier;
});

// returns minimum amount of contacts a user can buy
var minPurchasableContactsSelector = exports.minPurchasableContactsSelector = (0, _reselect.createSelector)([function (_, merchandiseId) {
  return merchandiseId;
}, numContactsInCrmSelector, contactsQuantityMultiplierSelector, purchasedContactsQuantitySelector], function (merchandiseId, numContactsInCrm, contactsQuantityMultiplier, purchasedContactsQuantity) {
  // missing information in state
  if (numContactsInCrm === null || !contactsQuantityMultiplier || !merchandiseId) {
    return null;
  }

  var includedAdditionalUnits = _ImmutableMerchandiseIdMap2.default[merchandiseId].includedAdditionalUnits;

  // hasn't bought contacts before

  if (!purchasedContactsQuantity) {
    // contacts in crm is fewer than minimum contacts purchase quantity
    if (numContactsInCrm < includedAdditionalUnits) {
      return includedAdditionalUnits;
    }
    // contacts in crm is fewer than quantity multiplier
    if (numContactsInCrm <= contactsQuantityMultiplier) {
      return contactsQuantityMultiplier;
    }
  }

  var purchasableContactsFromCrm = Math.ceil(numContactsInCrm / contactsQuantityMultiplier) * contactsQuantityMultiplier;

  return Math.max(purchasableContactsFromCrm, purchasedContactsQuantity);
});

var emailSendMultiplierSelector = exports.emailSendMultiplierSelector = function emailSendMultiplierSelector(state, merchandiseId) {
  var merchandise = (0, _MerchandiseSelectors.merchandiseSelector)(state);
  if (!merchandise || !merchandiseId) {
    return null;
  }
  var limits = merchandise[merchandiseId].limits;

  var emailSendLimitObject = limits.filter(function (limit) {
    return limit.name === 'email_sends';
  });

  if (emailSendLimitObject.length === 0) {
    return null;
  }

  var emailSendLimit = emailSendLimitObject[0].limit;
  var quantityMultiplier = contactsQuantityMultiplierSelector(state, merchandiseId);

  return emailSendLimit / quantityMultiplier;
};

var contactsLimitsDependenciesSelector = exports.contactsLimitsDependenciesSelector = (0, _reselect.createSelector)(numContactsInCrmSelector, purchasedContactsUnitsSelector, function (numContactsInCrm, purchasedContactsUnits) {
  return {
    numContactsInCrm: numContactsInCrm,
    purchasedContactsUnits: purchasedContactsUnits
  };
});


//////////////////
// WEBPACK FOOTER
// ./js/selectors/ContactsSelectors.js
// module id = 161
// module chunks = 3 4 5